
//// ajax Collection 

(function($, window, undefined) {

  var defaults = {
    loadingClass:'ajaxLoadingCollection',
    queryStringOptions:[false,false,false],
    collection:'/collections/all',
    view:'ajax',
    scrollToTop:true,
    virtual:false,
    page:{
      current:1,
      next:false,
      prev:false
    },
    tags:[],
    onUpdate:false
  }
  
  function wbskAjaxCollection(element, settings) { 
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.bind()
  }

  wbskAjaxCollection.prototype = {
    
    bind:function(){
      var _this = this
      $(window).on('popstate', function (e) {
        location.reload(); 
      });
    },
    
    getOptionsQueryString:function(){
      var data  = {},
          queryString = this.settings.queryStringOptions;
      
      if(queryString){
        Object.keys(queryString).forEach(function(item){
          if(queryString[item]){
            data[item] = queryString[item]
          }
        })
        if(Object.keys(data).length){
          return $.param(data)
        }else{
          return false
        }
      }else{
        return false
      }
    },
    
    updateURL:function(){
      var _this = this,
          newurl = `${window.location.protocol}//${window.location.host}${_this.buildURL()}`;
      window.history.pushState({path:newurl},'',newurl);
    }, 
    
    buildURL:function(){
      var tags = this.settings.tags,
          queryString = this.getOptionsQueryString(),
          sortBy  = this.settings.sortBy,
          type = this.settings.type,
      url = `${this.settings.collection}${tags.length ? `/${tags.join('+')}` : ''}?${type ? `q=${type}&` : ''}${sortBy ? `sort_by=${sortBy}&` : ''}page=${this.settings.page.current}`
      return url
    },
    
    update:function(updateURL){
     
      var _this = this, 
          url =  `${_this.buildURL()}&view=${_this.settings.view}`;
      

      
      return new Promise(function(resolve,reject){
         
        if(!_this.settings.virtual){
          if(_this.settings.scrollToTop && $(window).scrollTop() > 500){
            $(window).scrollTop(0);
          }
          if(_this.settings.loadingClass && _this.settings.loadingClassElement){
            _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
          }
        }

        _this.get(url).then(function(html){
 
          // if promise, return the html as promose, else justupdate the target
          if(_this.settings.virtual){
            resolve(html)
          }else{
            if(updateURL){
              _this.updateURL()
            }
            if(_this.settings.loadingClass && _this.settings.loadingClassElement){
              _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
            }    
            //emit update event
            var event = new CustomEvent('update' , {bubbles: true});
            event.wbskAjaxCollection = _this
            _this.element[0].dispatchEvent(event);    
            // run onUpdate event
            if (typeof _this.settings.onUpdate === "function") {
              _this.settings.onUpdate(_this)
            }
            $(_this.element).html(html)
            resolve()
          }
        
        })
      })    
    },
   
    get:function(url){
      return new Promise(function(resolve,reject){
        fetch(url).then(function(result){
          return result.text();
        }).then(function(html){
          resolve(html);
        })
      })
    }
  }

  $.fn.wbskAjaxCollection = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskAjaxCollection', new wbskAjaxCollection(this, settings))
    })
  }

}(jQuery, window));